;
/*!
 * subitotexto.videotq.js
 * Videos TéléQuébec
 */


SubitoTexto.videoTq = {
	init             : function () {
		var $ = jqPla,
			_this = SubitoTexto.videoTq;

		_this.$allVideoTqContainers = $( '.video-tq' );

		if ( _this.$allVideoTqContainers.length < 1  ) {
			return;
		}

		_this.$allVideoTqContainers.each(function(i, el) {
			jQuery(this).Tq_VideoPlayer();
		});


	}

};

